var preferences = {};

preferences.idVehicule = "";

preferences.setIdVehicule = function (newId) {
	if ( newId && newId != "" ) {
		preferences.idVehicule = newId;
	}
}

preferences.getCleanedURI = function (URItoClean) {
	return URItoClean.clone().query("");
}

preferences.getItemLocation = function (idPreference) {
	return window.localStorage.getItem(preferences.getCleanedURI(URI()) + preferences.idVehicule + "/" + idPreference);
}

preferences.setItemLocation = function (idPreference, valeur) {
	window.localStorage.setItem(preferences.getCleanedURI(URI()) + preferences.idVehicule + "/" + idPreference, valeur);
}

preferences.getItemVehicle = function (idPreference) {
	var currentVehicleURL = preferences.cleanURLVehicle();
	return window.localStorage.getItem(currentVehicleURL + idPreference);
}

preferences.setItemVehicle = function (idPreference, valeur) {
	var currentVehicleURL = preferences.cleanURLVehicle();
	window.localStorage.setItem(currentVehicleURL + idPreference, valeur);
}

preferences.cleanURLVehicle = function () {
	var currentVehicleURL = window.location.origin + window.location.pathname;
	var splitURL = currentVehicleURL.split("/");
	if ( splitURL.length > 5 ) {
		splitURL.pop();
		splitURL.pop();
	}
	splitURL.push(preferences.idVehicule);
	return splitURL.join("/");
}